import { render, staticRenderFns } from "./RequestToPurchase.vue?vue&type=template&id=7a5d2094"
import script from "./RequestToPurchase.vue?vue&type=script&lang=js"
export * from "./RequestToPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports